module.exports = "/images/vendor/@milestoneslabs/milestones-ui-kit/src/static/project-icons/move.svg?02086be43956b5531d1cba20628d1e41";